"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIAbstractPageGridContent;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UIMain = _interopRequireDefault(require("../layout/UIMain"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _sizes = require("HubStyleTokens/sizes");

var Outer = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__Outer",
  componentId: "sc-1abaf6e-0"
})(["display:flex;flex-wrap:nowrap;margin-left:-16px;margin-right:-16px;@media only screen and (max-width:", "){flex-wrap:wrap;}"], _sizes.GRID_BREAKPOINT_SMALL);

var Sidebar = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__Sidebar",
  componentId: "sc-1abaf6e-1"
})(["flex:0 0 33%;max-width:224px;padding-left:16px;padding-right:16px;position:relative;@media only screen and (max-width:", "){flex-basis:100%;max-width:none;}"], _sizes.GRID_BREAKPOINT_SMALL);

var MainContainer = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__MainContainer",
  componentId: "sc-1abaf6e-2"
})(["flex:1 0 0%;max-width:", ";padding-left:16px;padding-right:16px;position:relative;@media only screen and (max-width:679px){max-width:", ";}@media only screen and (max-width:", "){flex-basis:100%;max-width:100%;}"], function (_ref) {
  var hasSidebar = _ref.hasSidebar;
  return hasSidebar ? 'calc(100% - 224px)' : '100%';
}, function (_ref2) {
  var hasSidebar = _ref2.hasSidebar;
  return hasSidebar && '67%';
}, _sizes.GRID_BREAKPOINT_SMALL);

var STICKY_STYLES = (0, _styledComponents.css)(["height:100vh;margin-left:-", ";overflow-y:auto;padding-left:", ";position:sticky;top:0;@media only screen and (max-width:", "){height:auto;}"], _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.GRID_BREAKPOINT_SMALL);

var SidebarContainer = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__SidebarContainer",
  componentId: "sc-1abaf6e-3"
})(["", ";"], function (props) {
  return props.stickySidebar && STICKY_STYLES;
});

function UIAbstractPageGridContent(props) {
  var children = props.children,
      sidebarComponent = props.sidebarComponent,
      stickySidebar = props.stickySidebar;
  return _react.default.createElement(Outer, null, sidebarComponent && _react.default.createElement(Sidebar, null, _react.default.createElement(SidebarContainer, {
    stickySidebar: stickySidebar
  }, CustomRenderer.render(sidebarComponent))), _react.default.createElement(MainContainer, {
    hasSidebar: !!sidebarComponent
  }, _react.default.createElement(_UIMain.default, {
    flush: true
  }, children)));
}

UIAbstractPageGridContent.propTypes = {
  children: _propTypes.default.node,
  sidebarComponent: CustomRenderer.propType,
  stickySidebar: _propTypes.default.bool
};
UIAbstractPageGridContent.defaultProps = {
  stickySidebar: false
};
UIAbstractPageGridContent.displayName = 'UIAbstractPageGridContent';
module.exports = exports.default;